import { atom, useAtom } from 'jotai'
import { usePriceIntentValueOrThrow } from '@/features/priceCalculator/usePriceIntent'
import { setInsurelyConfig } from '@/services/Insurely/InsurelyIframe'
import { useTracking } from '@/services/Tracking/useTracking'
import { datadogRum } from '@datadog/browser-rum'
import { useShopSessionCustomer } from '../priceCalculator/useShopSessionCustomer'

type InsurelyState = 'INITIAL' | 'COMPARE' | 'RESULTS' | 'SUCCESS' | 'DISMISSED'

const insurelyStateAtom = atom<InsurelyState>('INITIAL')

export function useFetchInsurance() {
  const [state, setState] = useAtom(insurelyStateAtom)
  const tracking = useTracking()
  const priceIntent = usePriceIntentValueOrThrow()
  const shopSessionCustomer = useShopSessionCustomer()

  return {
    state,
    compare() {
      tracking.reportInsurelyAccepted({
        id: priceIntent.product.id,
        displayNameFull: priceIntent.product.displayNameFull,
      })
      datadogRum.addAction('Fetch Insurance Compare', {
        priceIntentId: priceIntent.id,
        companyName: priceIntent.externalInsurer?.displayName ?? undefined,
        productName: priceIntent.product.name,
      })
      setInsurelyConfig({
        company: priceIntent.externalInsurer?.insurelyId ?? undefined,
        ssn: shopSessionCustomer?.ssn ?? undefined,
        hideResultsView: true,
      })

      setState('COMPARE')
    },
    success() {
      tracking.reportInsurelyCorrectlyFetched({
        id: priceIntent.product.id,
        displayNameFull: priceIntent.product.displayNameFull,
      })

      setState('RESULTS')
    },
    confirmResults() {
      setState('SUCCESS')
    },
    dismiss() {
      setState('DISMISSED')
    },
  }
}
